import useGreeksWebsocketDataStore from '../Store/GreeksWebsocketDataStore';
import usePlaybackStore from '../Store/playbackStore';
import { useEffect } from 'react'

const Zero_DTE_Greeks_Websocket_Client = ({ memberCredentials }) => {
  const {
    setInitialData,
    updateGreekExposures,
    updateTopOptions,
    updateDynamicLevels,
    updateGexTrendStrength,
    setConnectionStatus,
    recordObservation,
  } = useGreeksWebsocketDataStore();

  useEffect(() => {
    let ws = null;
    let reconnectTimeout = null;
    let heartbeatInterval = null;

    const connectWebSocket = () => {
      const wsUrl = process.env.REACT_APP_GREEKS_WEBSOCKET_URL;

      setConnectionStatus('connecting');
      ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        setConnectionStatus('connected');
        const authMessage = {
          type: 'authenticate',
          data: {
            memberId: memberCredentials.memberId,
            status: memberCredentials.status
          }
        };
        ws.send(JSON.stringify(authMessage));
      };

      ws.onmessage = (event) => {
          try {
            const response = JSON.parse(event.data);
            const playback = usePlaybackStore.getState();
            const replaying = playback.mode === 'playing';

            switch (response.type) {
              case 'initial_data':
                recordObservation(Date.now());
                if (replaying) playback.queueLiveGreekInitial(response.spx);
                else setInitialData('spx', response.spx);

                heartbeatInterval = setInterval(() => {
                  if (ws.readyState === WebSocket.OPEN) {
                    ws.send(JSON.stringify({ type: 'ping' }));
                  }
                }, 30000);
                break;

              case 'update': {
                const { index } = response;

                // 1) Guard: missing index
                if (!index) {
                  console.warn('Update received without index specification');
                  return;
                }

                // 2) Normalize and filter: accept "SPX", "spx", or "I:SPX"
                const norm = String(index).replace(/^I:/i, '').toLowerCase();
                if (norm !== 'spx') return;
                recordObservation(Date.now());

                // 3) Apply updates only for SPX, and use a consistent key
                if (response.gex_trend) {
                  const update = {
                    updateData: response.gex_trend,
                    timestamp: new Date().toISOString(),
                  };
                  if (replaying) playback.queueLiveGreekOp('gexTrend', update);
                  else updateGexTrendStrength('spx', update);
                }
                if (response.greek_exposures) {
                  if (replaying) {
                    playback.queueLiveGreekOp('greekExposures', response.greek_exposures);
                  } else {
                    updateGreekExposures('spx', response.greek_exposures);
                  }
                }
                if (response.top_options) {
                  if (replaying) playback.queueLiveGreekOp('topOptions', response.top_options);
                  else updateTopOptions('spx', response.top_options);
                }
                if (response.dynamic_levels) {
                  if (replaying) {
                    playback.queueLiveGreekOp('dynamicLevels', response.dynamic_levels);
                  } else {
                    updateDynamicLevels('spx', response.dynamic_levels);
                  }
                }
                return;
              }
              case 'pong':
                break;

              default:
                console.warn('Unrecognized message type:', response.type);
            }
          } catch (error) {
            // console.error('Error processing WebSocket message:', error);
            // console.error('Raw message:', event.data);
          }
      };

      ws.onclose = (event) => {
        // console.log('WebSocket connection closed:', event);
        if (heartbeatInterval) {
          clearInterval(heartbeatInterval);
          heartbeatInterval = null;
        }
        setConnectionStatus('disconnected');
        scheduleReconnect();
      };

      ws.onerror = (error) => {
        setConnectionStatus('disconnected');
        console.error('Greeks WebSocket encountered an error:', error);
      };
    };

    const scheduleReconnect = () => {
      if (reconnectTimeout) return;
      console.log('Scheduling reconnection...');
      reconnectTimeout = setTimeout(() => {
        connectWebSocket();
        reconnectTimeout = null;
      }, 1000);
    };

    const cleanupWebSocket = () => {
      console.log('Cleaning up WebSocket connection');
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
        reconnectTimeout = null;
      }

      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
        heartbeatInterval = null;
      }

      if (ws) {
        ws.onopen = null;
        ws.onmessage = null;
        ws.onclose = null;
        ws.onerror = null;

        if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
          ws.close();
        }
        ws = null;
      }
    };

    if (memberCredentials?.memberId && memberCredentials?.status) {
      console.log('Initiating WebSocket connection');
      connectWebSocket();
    } else {
      console.log('No valid credentials provided');
    }

    return () => {
      cleanupWebSocket();
    };
  }, [
    setInitialData,
    updateGreekExposures,
    updateTopOptions,
    updateDynamicLevels,
    updateGexTrendStrength,
    setConnectionStatus,
    recordObservation,
    memberCredentials
  ]);

  return null;
};

export default Zero_DTE_Greeks_Websocket_Client;
















